<template>
  <Form
    :validation-schema="schema"
    class="ask-lawyer-card"
    @submit="onSubmit"
  >
    <div class="input-grp mb-3">
      <label for="title">Ask Your Question</label>
      <Field
        name="title"
        placeholder="title"
        class="primary-input"
      />
      <ErrorMessage
        name="title"
        class="form_error"
      />
    </div>
    <div class="input-grp mb-3">
      <label for="description">Explain Your Situation</label>
      <Field
        id="description"
        name="description"
        as="textarea"
        cols="30"
        rows="10"
        class="primary-input custom"
        placeholder="Write your message"
      />
      <ErrorMessage
        name="description"
        class="form_error"
      />
    </div>
    <div class="input-grp mb-3">
      <label for="city">Select District</label>
      <Field
        id="city"
        name="city"
        as="select"
        class="primary-input"
      >
        <option
          value=""
          selected
          disabled
        >
          Please Select (Eg.: Kathmandu)
        </option>
        <option
          v-for="city in cities"
          :key="city.city"
          :value="city.city"
        >
          {{ city.city }}
        </option>
      </Field>
      <ErrorMessage
        name="city"
        class="form_error"
      />
    </div>
    <div class="input-grp button-container">
      <SubmitButtonComponent
        :is-loading="loading"
        label="Submit"
        class="primary-button"
      />
    </div>
  </Form>
</template>

<script>
import {Form, Field, ErrorMessage} from 'vee-validate'
import SubmitButtonComponent from '@/components/ButtonComponent/SubmitButtonComponent.vue'
import {ref, computed, onMounted} from 'vue'
import {useRouter} from 'vue-router'
import {useDistrictStore, useQuestionStore} from '@/store'
import * as yup from 'yup'

export default {
  name: 'AskALawyer',
  components: {
    Form,
    Field,
    ErrorMessage,
    SubmitButtonComponent,
  },

  setup() {
    const districtStore = useDistrictStore()
    const questionStore = useQuestionStore()
    const router = useRouter()

    const isAuth = ref(false)

    onMounted(async () => {
      if (window.$cookies.get('auth')) {
        isAuth.value = true
      }
      await districtStore.getAllDistricts()
    })

    const cities = computed(() => districtStore.allDistricts)
    const loading = computed(() => questionStore.loading)

    const schema = yup.object().shape({
      title: yup
        .string()
        .required((data) => `The ${data.path} field is required`),
      description: yup
        .string()
        .required((data) => `The ${data.path} field is required`),
      city: yup
        .string()
        .required((data) => `The ${data.path} field is required`),
    })

    const onSubmit = async (values) => {
      questionStore.persistQuestion(values)
      if (isAuth.value) {
        router.push({path: '/review-question'})
      } else {
        router.push('/SignIn')
      }
    }

    return {
      schema,
      cities,
      loading,
      onSubmit,
    }
  },
}
</script>
<style scoped>
.lds-ring-container {
  left: 26rem;
}
</style>
